module.exports = __webpack_public_path__ + "img/W-G22-1.683f4ea2.jpg";